import { IWorkResource } from "../common/data/dtos/work-resource";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/WorkResource';

interface WorkResourceResponse {
    success: boolean;
    workResource?: IWorkResource;
    workResources?: IWorkResource[];
    error?: string;
}

type CreateWorkResourceType = Omit<IWorkResource, 'id'> | Partial<IWorkResource>;

const createWorkResource = async (company: CreateWorkResourceType): Promise<WorkResourceResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}`, company);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkResource= async (id: string): Promise<WorkResourceResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkResources = async (): Promise<WorkResourceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResources: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneWorkResource = async (id: string): Promise<WorkResourceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResource: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateWorkResource = async (company: IWorkResource): Promise<WorkResourceResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}/${company.id}`, company);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getExpiringWorkResourcesByDueDate = async (days: number): Promise<WorkResourceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResource>(`${BASE_PATH}/GetExpiringByDueDate?days=${days}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResources: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createWorkResource,
    deleteWorkResource,
    getWorkResources,
    getOneWorkResource,
    updateWorkResource,
    getExpiringWorkResourcesByDueDate,
};
